import { render } from "./AddInvest.vue?vue&type=template&id=7d226e6c&scoped=true"
import script from "./AddInvest.vue?vue&type=script&lang=js"
export * from "./AddInvest.vue?vue&type=script&lang=js"

import "./AddInvest.vue?vue&type=style&index=0&id=7d226e6c&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d226e6c"]])

export default __exports__